import { render, staticRenderFns } from "./InterviewListingBody.vue?vue&type=template&id=6887327a&scoped=true"
import script from "./InterviewListingBody.vue?vue&type=script&lang=ts"
export * from "./InterviewListingBody.vue?vue&type=script&lang=ts"
import style0 from "./InterviewListingBody.vue?vue&type=style&index=0&id=6887327a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6887327a",
  null
  
)

export default component.exports